import { yupResolver } from '@hookform/resolvers/yup';
import SearchIcon from '@mui/icons-material/Search';
import { CardHeader } from '@mui/material';
import { useForm } from 'react-hook-form';
import { debounce } from 'utils/debounce';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { storeSchema } from 'v3/shared/schemas/stores';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';

import { DEBOUNCE_ONE_SECOND } from 'common/constants';
import { clearAllFilters, setFilterSearchStore } from 'v3/data/store/stores/actions';
import { CardContentStyled, CardStyled } from 'v3/shared/components/Filters/StoreListFilter/styles';
import { StoreListFilterType } from 'v3/shared/components/Filters/StoreListFilter/types';

export const StoreListFilter = () => {
  const { control, setValue, clearErrors } = useForm<StoreListFilterType>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(storeSchema) as any,
  });

  const handleSearchStore = (searchStore: string) => {
    setFilterSearchStore(searchStore);
  };

  const debouncedHandleSearchStore = (searchStore: string) => {
    debounce(() => handleSearchStore(searchStore), 1500, 'handleSearchStore');
  };

  const handleOnChangeSearch = (searchStore: string) => {
    debouncedHandleSearchStore(searchStore);
  };

  const handleClearFilter = () => {
    setValue('searchStore', '');
    clearAllFilters();
    clearErrors();
  };

  return (
    <CardStyled>
      <CardHeader title={<BodyLarge>Filtros</BodyLarge>} />
      <CardContentStyled>
        <InputFormController
          data-testid="input-store"
          formControl={control}
          formControlName="searchStore"
          placeholder="Procurar por nome da loja, CNPJ ou JazzStoreID"
          fullWidth
          onChangeInput={handleOnChangeSearch}
          startAdornmentIcon={SearchIcon}
        />
        {/* <DropdownSelectFormController
          data-testid="select-form-controller-group"
          formControl={control}
          formControlName="group"
          label="Grupo"
          enumType={true}
          selectValues={StoreGroupEnum}
          onChangeSelect={handleOnChangeGroup}
          key={getValues('group')}
        /> */}
        <TextButton data-testid="clean" text="Limpar" handleClick={handleClearFilter} />
      </CardContentStyled>
    </CardStyled>
  );
};
